import { Box, Checkbox, Typography } from '@mui/material'
import { StyledTableCell } from '../invoice-table-body'
import { InvoiceResponse } from '../../../../../../store/invoices/invoices.types'
import {
  listPrimaryTextSx,
  listSecondaryTextSx,
} from 'components/list-table/list-table.styles'

interface InvoiceTableInvoiceIdProps extends InvoiceResponse {
  isSelected: boolean
  onSelect: (selected: boolean) => void
}

const InvoiceTableInvoiceId = (invoice: InvoiceTableInvoiceIdProps) => {
  const { userInvoiceId, loadNumber, isSelected, onSelect } = invoice

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onSelect(event.target.checked)
  }

  return (
    <StyledTableCell>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="flex-start"
        columnGap={1}
      >
        <Checkbox
          checked={isSelected}
          onChange={handleCheckboxChange}
          sx={{ padding: '4px' }}
        />
        <Box>
          <Typography sx={listPrimaryTextSx}>
            {userInvoiceId}
          </Typography>
          <Typography sx={listSecondaryTextSx}>
            {loadNumber}
          </Typography>
        </Box>
      </Box>
    </StyledTableCell>
  )
}

export default InvoiceTableInvoiceId
